import { useMemo } from 'react';
import { SelectOption } from '../@types';
import { useCasinoProviders } from '../queries/casino';

export const useCasinoProviderOptions = () => {
  const { data: providers = [], isLoading } = useCasinoProviders();

  const options = useMemo<SelectOption[]>(
    () =>
      providers.map((provider) => ({
        id: provider.name,
        name: provider.name,
      })),
    [providers]
  );

  return { options, isLoading };
};
